import React from 'react';
import { IconRight } from '@arco-design/iconbox-react-m4b-next';
import cx from 'classnames';
import styled from 'styled-components';
import styles from './index.scss';
import { useTranslation } from '@jupiter-app/plugin-i18n';

const Title = styled.div`
  max-width: 165px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export interface BreadCrumbItem {
  title: string;
  onClick?: () => void;
}

export interface BreadCrumbProps {
  className?: string;
  items: BreadCrumbItem[];
}

const BreadCrumb = (props: BreadCrumbProps) => {
  const { className, items } = props;
  const { t } = useTranslation();
  return (
    <div className={cx(styles.breadcrumb, className)}>
      {items.map((item, index) => {
        return (
          <div className="flex" key={index}>
            <Title
              key={index}
              className={item.onClick && styles.breadcrumbItem}
              onClick={item.onClick}>
              {t(item.title)}
            </Title>
            {index < items.length - 1 ? (
              <div className={styles.divisionIcon}>
                <IconRight />
              </div>
            ) : undefined}
          </div>
        );
      })}
    </div>
  );
};

export default BreadCrumb;
